import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const certificateDeliveryMethodsSchema: CollectionCreateSchema = {
  name: CollectionName.CertificateDeliveryMethods,
  fields: [
    {
      name: "search_id",
      type: "string",
    },
    {
      name: "label",
      type: "string",
      infix: true,
    },
  ],
  visibility: CollectionVisibility.EC,
}
